var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramArt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 28,
    viewBox: "0 0 220 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_15509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.985 7.82287L22.3188 24.5056H5.6511L13.985 7.82287ZM13.985 0L0 28H27.9699L13.985 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9852 14.0371L9.9873 22.0178H17.9755L13.9852 14.0371Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_15509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5276 1.6084H63.3574V26.3848H67.5276V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8929 1.6084H74.7227V26.3848H78.8929V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5492 11.2157L64.7715 15.2344L66.1182 19.1812L77.8959 15.1625L76.5492 11.2157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6184 1.6416H43.9697V5.81181H58.6184V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3821 3.72656H49.2119V26.3582H53.3821V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7873 28L81.7793 13.1461L90.9538 0L94.3694 2.38298L86.9093 13.0733L96.1367 25.5177L92.7873 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4621 11.0283H84.3477V15.1985H94.4621V11.0283Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_15509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.866 26.7496L122.363 8.53367L116.214 26.7157L112.138 25.3364L120.264 1.28397L122.064 1.27038L124.334 1.25L132.922 25.3024L128.866 26.7496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.524 19.3008L122.536 16.3125L119.548 19.3008L122.536 22.2892L125.524 19.3008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.967 27.0352H136.659V0L152.979 9.03664L141.014 21.6268L140.967 21.5792V27.0352ZM140.967 7.30405V15.4234L146.022 10.1034L140.967 7.30405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.472 15.088L141.276 17.9766L150.334 27.9971L153.53 25.1086L144.472 15.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.992 1.16895H155.854V5.47664H170.992V1.16895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.576 3.32324H161.269V26.703H165.576V3.32324Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_15509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9699,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_15509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1674,
    height: 28,
    fill: "white",
    transform: "translate(43.9697)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_15509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.8537,
    height: 28,
    fill: "white",
    transform: "translate(112.138)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramArt);
export default __webpack_public_path__ + "static/media/programArt.1961962271f2a177320753e7322d6d38.svg";
export { ForwardRef as ReactComponent };